import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import Quiz from './AdminQuiz';
import { getBaseUrl } from '../../utils';

interface Props {
    getQuiz: (id: string) => Bee.ClientResponse['data'];
    onQuizSave: (id: string, quiz: Bee.Quiz) => Promise<Bee.ClientResponse>;
    match: {
        path: string;
        params: {
            quizId: string;
        };
    };
    history: { push: (path: string) => void; };
    location: { hash: string };
    classes: {
        container: string;
        date: string;
        question: string;
        divider: string;
        preview: string;
        remove: string;
        questionBtn: string;
        questionBtns: string;
    };
}

interface State {
    quiz?: Bee.Quiz;
}

class EditQuiz extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            quiz: undefined,
        }
    }

    componentDidMount() {
        this.getQuiz();
    }

    private getQuiz = async () => {
        const rep = await this.props.getQuiz(this.props.match.params.quizId);
        if (rep.id && rep.answers && rep.questions) {
            this.setState({ quiz: rep });
        }
    }

    private onQuizSave = (quiz: Bee.Quiz): Promise<Bee.ClientResponse> | undefined => {
        if (this.state.quiz) {
            return this.props.onQuizSave(this.state.quiz.id, quiz);
        }
        return;
    }

  	render() {
        if (!this.state.quiz) {
            return (
                <React.Fragment>
                    <Typography variant="h3" gutterBottom align="center">Edit Quiz</Typography>
                    <Typography color="error" align="center" variant="h6">Unable to show quiz!</Typography>
                </React.Fragment>
            )
        }
        const back = `${getBaseUrl(this.props.match.path)}${this.props.location.hash}`;
        return (
            <Quiz {...this.props} quiz={this.state.quiz} back={back} edit onQuizSave={this.onQuizSave} />
        )
	}
}

export default EditQuiz;



// WEBPACK FOOTER //
// ./src/components/Admin/EditQuiz.tsx